/* tslint:disable */
/* eslint-disable */
/**
 * RateRelief API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReRateModel
 */
export interface ReRateModel {
    /**
     * 
     * @type {string}
     * @memberof ReRateModel
     */
    id?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ReRateModel
     */
    timePeriodDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ReRateModel
     */
    policyNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReRateModel
     */
    reRateStatus?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReRateModel
     */
    createdBy?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ReRateModel
     */
    createdDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof ReRateModel
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ReRateModel
     */
    fileName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReRateModel
     */
    fileSize?: number;
    /**
     * 
     * @type {string}
     * @memberof ReRateModel
     */
    requestFileGUID?: string;
    /**
     * 
     * @type {number}
     * @memberof ReRateModel
     */
    employeeMedicalEmployee?: number;
    /**
     * 
     * @type {number}
     * @memberof ReRateModel
     */
    employeeMedicalSpouse?: number;
    /**
     * 
     * @type {number}
     * @memberof ReRateModel
     */
    employeeMedicalChild?: number;
    /**
     * 
     * @type {number}
     * @memberof ReRateModel
     */
    employeeMedicalFamily?: number;
    /**
     * 
     * @type {number}
     * @memberof ReRateModel
     */
    currentPremiumEQ?: number;
    /**
     * 
     * @type {number}
     * @memberof ReRateModel
     */
    newPremiumEQ?: number;
    /**
     * 
     * @type {number}
     * @memberof ReRateModel
     */
    increase?: number;
    /**
     * 
     * @type {number}
     * @memberof ReRateModel
     */
    estimatedStandardNBRate?: number;
    /**
     * 
     * @type {string}
     * @memberof ReRateModel
     */
    reissueType?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ReRateModel
     */
    override?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReRateModel
     */
    optionsShutoff?: boolean;
}

/**
 * Check if a given object implements the ReRateModel interface.
 */
export function instanceOfReRateModel(value: object): value is ReRateModel {
    return true;
}

export function ReRateModelFromJSON(json: any): ReRateModel {
    return ReRateModelFromJSONTyped(json, false);
}

export function ReRateModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReRateModel {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'timePeriodDate': json['timePeriodDate'] == null ? undefined : (new Date(json['timePeriodDate'])),
        'policyNumber': json['policyNumber'] == null ? undefined : json['policyNumber'],
        'reRateStatus': json['reRateStatus'] == null ? undefined : json['reRateStatus'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'note': json['note'] == null ? undefined : json['note'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileSize': json['fileSize'] == null ? undefined : json['fileSize'],
        'requestFileGUID': json['requestFileGUID'] == null ? undefined : json['requestFileGUID'],
        'employeeMedicalEmployee': json['employeeMedicalEmployee'] == null ? undefined : json['employeeMedicalEmployee'],
        'employeeMedicalSpouse': json['employeeMedicalSpouse'] == null ? undefined : json['employeeMedicalSpouse'],
        'employeeMedicalChild': json['employeeMedicalChild'] == null ? undefined : json['employeeMedicalChild'],
        'employeeMedicalFamily': json['employeeMedicalFamily'] == null ? undefined : json['employeeMedicalFamily'],
        'currentPremiumEQ': json['currentPremiumEQ'] == null ? undefined : json['currentPremiumEQ'],
        'newPremiumEQ': json['newPremiumEQ'] == null ? undefined : json['newPremiumEQ'],
        'increase': json['increase'] == null ? undefined : json['increase'],
        'estimatedStandardNBRate': json['estimatedStandardNBRate'] == null ? undefined : json['estimatedStandardNBRate'],
        'reissueType': json['reissueType'] == null ? undefined : json['reissueType'],
        'override': json['override'] == null ? undefined : json['override'],
        'optionsShutoff': json['optionsShutoff'] == null ? undefined : json['optionsShutoff'],
    };
}

export function ReRateModelToJSON(json: any): ReRateModel {
    return ReRateModelToJSONTyped(json, false);
}

export function ReRateModelToJSONTyped(value?: ReRateModel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'timePeriodDate': value['timePeriodDate'] == null ? undefined : ((value['timePeriodDate']).toISOString()),
        'policyNumber': value['policyNumber'],
        'reRateStatus': value['reRateStatus'],
        'createdBy': value['createdBy'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'note': value['note'],
        'fileName': value['fileName'],
        'fileSize': value['fileSize'],
        'requestFileGUID': value['requestFileGUID'],
        'employeeMedicalEmployee': value['employeeMedicalEmployee'],
        'employeeMedicalSpouse': value['employeeMedicalSpouse'],
        'employeeMedicalChild': value['employeeMedicalChild'],
        'employeeMedicalFamily': value['employeeMedicalFamily'],
        'currentPremiumEQ': value['currentPremiumEQ'],
        'newPremiumEQ': value['newPremiumEQ'],
        'increase': value['increase'],
        'estimatedStandardNBRate': value['estimatedStandardNBRate'],
        'reissueType': value['reissueType'],
        'override': value['override'],
        'optionsShutoff': value['optionsShutoff'],
    };
}

